import React from "react";
import './pages.css'
import './pagesResponsiveStylesheet.css'
import Icon from "../Assets/IconLibrary/Icon";
import Popup from "reactjs-popup";
import Suresh from '../Assets/Images/Company/suresh.png'
import JiaZeng from '../Assets/Images/Company/jiazeng.png'
import vision from '../Assets/Images/Company/vision.svg'
import mission from '../Assets/Images/Company/mission.svg'
import values from '../Assets/Images/Company/values.svg'
import HeadSection from "../Components/HeadSection/HeadSection";
import {onLoadImages} from "../Components/CommonMethod";

class Company extends React.Component {
    constructor(props) {
        super(props);
        this.containerRef = React.createRef()
        this.state = {
            imageLoaded: false,
            autoPlay: false,
            contextPopup: false,
            contextPopupTitle: "Company",
            contextPopupTag: "About IP Agent AI",
            textInfo: [],
            showVideo: false,
            leadershipTeam: [
                {
                    Image: Suresh,
                    Name: 'Suresh Vallabhaneni',
                    Position: 'Founder & CEO',
                    BriefInfo: "Suresh Vallabhaneni is a serial entrepreneur with over 24 years of experience in the software industry.",
                    Data: ['Suresh Vallabhaneni is a serial entrepreneur with over 24 years of experience in the software industry. Prior to IP Agent AI, Suresh was the founder and CEO of Zing Wallet, a mobile payments startup and Adagesoft, a solutions provider. Before venturing into startups, Suresh has worked at various Fortune 500 companies like Goldman Sachs, Freddie Mac and technology companies like BEA Systems.',
                        'Suresh has a Masters in Computer Science from Andhra University India and Certificate in Entrepreneurship from Stanford Graduate School of Business.'
                    ]
                },
                {
                    Image: JiaZeng,
                    Name: 'Jia Zeng',
                    Position: 'Co-Founder',
                    BriefInfo: "Jia Zeng holds a BS in Computer Science with a minor in Machine Learning.",
                    Data: ['Jia Zeng holds a BS in Computer Science with a minor in Machine Learning. She is passionate about building high-performance computing systems in the space of AI and likes to paint to reenergize her.']
                },
            ],
            teamMemberPopup: false,
            memberName: '',
            context: {
                about: [
                    "IP Agent AI is a data-driven intelligence platform that helps people quickly turn\n" +
                    "their data into actionable insights. Founded to democratize AI and make it\n" +
                    "accessible to everyone, IP Agent AI provides an intuitive, easy-to-use interface\n" +
                    "based on the user's skillset. With just a few clicks, anyone can create an\n" +
                    "intelligent application that learns from new inputs without ever writing code.",

                    "Since 2019, IP Agent AI has been helping businesses turn their data into\n" +
                    "powerful, valuable insights in the blink of an eye. The perfect tool for anyone\n" +
                    "who wants to make their business smarter without learning how to code,\n" +
                    "IP Agent AI empowers businesses of all sizes to create and use AI solutions in\n" +
                    "minutes.",

                    "Headquartered in Palo Alto, California, IP Agent AI allows business executives,\n" +
                    "engineers, and organizational leaders to quickly and easily create custom AI\n" +
                    "solutions that identify, address, and solve unique, specific business\n" +
                    "problems. Designed to provide a streamlined, simplified, and intuitive user\n" +
                    "experience fueled by artificial intelligence, IP Agent AI delivers an adaptive\n" +
                    "interface that makes it simple for anyone to create AI solutions quickly and\n" +
                    "effectively.",

                    "As the volume and complexity of the data grows, finding the signal in the noise\n" +
                    "becomes increasingly difficult. Without the help of AI, most businesses\n" +
                    "cannot make sense of their data and turn it into valuable insights. As enterprises are collecting more data than ever before, the collection of data has grown at an unprecedented rate.. This influx of data has made it difficult for\n" +
                    "businesses to keep up with the latest trends and make informed decisions.",

                    "IP Agent AI was born out of a commitment to address and solve this problem by\n" +
                    "simplifying AI and making it more accessible and valuable for businesses of\n" +
                    "all sizes. We developed our groundbreaking, innovative AI Lifecycle platform\n" +
                    "to help our customers transform their data into actionable insights without\n" +
                    "coding or expertise. With IP Agent AI, you can get insights from your data in\n" +
                    "minutes instead of months. You'll be able to make decisions quickly and\n" +
                    "efficiently to stay ahead of the competition.",
                ],
                vision: [
                    "IP Agent AI is an AI Lifecycle platform that believes in something bigger. Our\n" +
                    "mission is to be an industry disrupter and a difference-maker by providing a\n" +
                    "powerful way for businesses to harness the power of their data. IP Agent AI is\n" +
                    "the culmination of years of passion, determination, and personal experiences\n" +
                    "that have been developed throughout the career of IPAgent’s founding team.\n" +
                    "Our love for startups and technology is at the core of what we do, and we\n" +
                    "have remained committed to revolutionizing the landscape of business and\n" +
                    "data in the 21st century.",

                    "We believe \"good enough\" is never enough, and this belief is at the very\n" +
                    "heart of what we do. At IP Agent AI, our goal is to make sophisticated\n" +
                    "technology accessible to businesses ready to take their success to the next\n" +
                    "level by making AI technology more accessible to all.",
                ]
            }
        }
    }

    componentDidMount() {
        let imageLoaded = onLoadImages(this.containerRef)
        this.setState({
            imageLoaded
        })
    }

    teamMemberInfo = (name) => {
        let leadershipTeam = [...this.state.leadershipTeam];
        leadershipTeam.forEach(leadershipTeam => {
            if (leadershipTeam.Name === name) {
                this.setState({teamMemberPopup: !this.state.teamMemberInfo, memberName: name})
            }
        })
    };

    render() {
        return (
            <div className='company' ref={this.containerRef}>
                <HeadSection keyword={"company"}/>

                <div className='company-about'>
                    <div className="company-team-image-section" style={{height: "400px"}}>
                        <img src={vision} alt={"Team"} loading={"lazy"}/>
                    </div>
                    <div className='company-about-content'>
                        <h2 className='header-text company-main-title'>Our Vision</h2>
                        <div className='company-text company-text-about'>
                            <p>
                                To revolutionize the Intellectual Property (IP) industry by becoming the global leader
                                in Agentic AI-powered innovation, empowering IP professionals with intelligent,
                                adaptive, and precise solutions that redefine workflows, accelerate decision-making, and
                                unlock limitless possibilities. We envision a future where technology seamlessly
                                simplifies complex IP processes, enabling professionals to focus on strategic creativity
                                and delivering unparalleled value to their clients in an ever-evolving global landscape.
                            </p>
                        </div>

                    </div>


                </div>


                <div className='company-about'>
                    <div className='company-about-content'>
                        <h2 className='header-text company-main-title'>
                            Our Mission</h2>
                        <div className='company-text company-text-about'>
                            <p>
                                Our mission is to empower Intellectual Property (IP) professionals with the world’s most
                                advanced and sophisticated Agentic AI-powered IP platform, meticulously designed to
                                deliver exceptional results with unparalleled speed and precision.
                            </p>
                            <p>
                                Our proprietary Agentic AI technology leverages cutting-edge innovations to help IP
                                professionals transform complex processes into streamlined, simple steps. By
                                accelerating decision-making, it empowers them to deliver exceptional value and
                                impactful results to their clients. Our platform adapts swiftly to the ever-changing
                                needs of IP professionals, delivering tools that guarantee precision while significantly
                                reducing manual effort across varied geographies, regulatory frameworks, and intricate
                                process nuances.
                            </p>
                            <p>
                                With a focus on excellence, we are committed to transforming how IP work is done,
                                instantly delivering infinite value at infinitesimal cost, unlocking IP Professionals
                                from the shackles of legacy softwares.
                            </p>
                        </div>

                    </div>
                    <div className="company-team-image-section">
                        <img src={mission} alt={"Team"} loading={"lazy"}/>
                    </div>
                </div>
                <div className='company-about'>
                    <div className="company-team-image-section">
                        <img src={values} alt={"Team"} loading={"lazy"}/>
                    </div>
                    <div className='company-about-content'>
                        <h2 className='header-text company-main-title'>Our Values</h2>
                        <div className='company-text company-text-about'>
                            <p>
                                At IP Agent AI, our values define who we are and how we operate. The below values guide
                                our decisions, shape our culture, and drive our commitment to excellence. </p>
                            <ul>
                                <li>
                                    <div className="company-text-list-item">
                                        <b>Integrity</b>
                                        We conduct business with honesty, transparency, and ethical responsibility.
                                    </div>
                                </li>
                                <li>
                                    <div className="company-text-list-item">
                                        <b>Innovation </b>
                                        We embrace creativity and continuous improvement to deliver cutting-edge
                                        solutions.

                                    </div>
                                </li>
                                <li>
                                    <div className="company-text-list-item">
                                        <b>Customer Commitment </b>
                                        We prioritize our customers’ needs, ensuring exceptional service and lasting
                                        relationships.

                                    </div>
                                </li>
                                <li>
                                    <div className="company-text-list-item">
                                        <b>Collaboration </b>
                                        We foster a culture of teamwork, inclusivity, and mutual respect.
                                    </div>
                                </li>
                                <li>
                                    <div className="company-text-list-item">
                                        <b>Excellence </b>
                                        We strive for the highest quality in everything we do, exceeding expectations at
                                        every level.
                                    </div>
                                </li>
                                <li>
                                    <div className="company-text-list-item">
                                        <b>Sustainability</b>
                                        We are dedicated to responsible business practices that benefit our community
                                        and environment.
                                    </div>
                                </li>
                            </ul>
                            <p>
                                These values shape our journey and inspire us to create a better future for our
                                customers, employees, and stakeholders.

                            </p>
                        </div>

                    </div>


                </div>

                <div className='team-container'>
                    <h2 className='header-text company-main-title'>Our Leadership Team</h2>
                    <div className='team-image-container'>
                        {
                            this.state.leadershipTeam.map((leaderTeam, tid) =>
                                <div className="team-image-profile-container"
                                     onClick={() => this.teamMemberInfo(leaderTeam.Name)}>
                                    <img src={leaderTeam.Image}
                                         loading={"lazy"}
                                         width={"100%"}
                                         height={"100%"}
                                         className={tid / 2 !== 0 ? "team-profile-img right-image" : "team-profile-img"}
                                         alt={leaderTeam.Name}/>
                                    <div className="team-info">
                                        <h3 className='team-info-name'>{leaderTeam.Name}</h3>
                                        <div className='team-info-position'>- {leaderTeam.Position} -</div>
                                        <div className='team-info-brief'>{leaderTeam.BriefInfo}</div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>

                <Popup open={this.state.teamMemberPopup}
                       overlayStyle={{backgroundColor: 'rgba(0,0,0,70%)'}}
                       onClose={() => this.setState({teamMemberPopup: false})}
                       contentStyle={{
                           background: "transparent",
                           padding: 0,
                           border: "none",
                           borderRadius: "none",
                           minWidth: "100px"
                       }}
                >
                    {
                        this.state.leadershipTeam.map(leaderList =>
                            this.state.memberName === leaderList.Name &&
                            <div className="profile-detail-info-popup">
                                <div className="profile-detail-info-layout">
                                    <div className='company-team-info-container'>

                                        <button className='company-team-info-close'
                                                onClick={() => this.setState({teamMemberPopup: !this.state.teamMemberPopup})}>
                                            <Icon name={'close'} size={20} colorList={["white"]}/>
                                        </button>
                                        <div className='company-team-info-image-container'>
                                            <img src={leaderList.Image}
                                                 loading={"lazy"}
                                                 width={150}
                                                 height={"100%"}
                                                 alt={leaderList.Name}/>

                                            <div style={{
                                                gap: 10,
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}>
                                                <h1 className='header-text popup-company-main-title'>{leaderList.Name}
                                                </h1>
                                                <div
                                                    className='company-position'>{leaderList.Position}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='company-team-info-body'
                                             style={{
                                                 gap: 20,
                                                 display: 'flex',
                                                 flexDirection: 'column'
                                             }}>

                                            {
                                                leaderList.Data.map(leaderInfo =>
                                                    <div>{leaderInfo}</div>
                                                )
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    }


                </Popup>

                <Popup contentStyle={{
                    background: "transparent",
                    padding: 0,
                    border: "none",
                    borderRadius: "none",
                }}
                       open={this.state.contextPopup}
                       overlayStyle={{backgroundColor: 'rgba(0,0,0,70%)'}}
                       onClose={() => this.setState({contextPopup: false})}>
                    <div className="context-popup">
                        <div className="context-popup--header">
                            <button className="context-popup-close-btn"
                                    onClick={() => this.setState({contextPopup: false})}>
                                <Icon name={'close'} size={20}/>
                            </button>
                            <div className="context-popup-tag">{this.state.contextPopupTag}</div>
                            <div className="context-popup-title">{this.state.contextPopupTitle}</div>
                        </div>
                        <div className="context-popup--body">


                            {
                                this.state.textInfo.map((text) =>
                                    <p>{text}</p>
                                )
                            }

                        </div>
                    </div>

                </Popup>
            </div>
        )
    }
}

export default Company;